import { render } from "./ComplianceOnboardingWizard.vue?vue&type=template&id=606f947d&scoped=true"
import script from "./ComplianceOnboardingWizard.vue?vue&type=script&lang=js"
export * from "./ComplianceOnboardingWizard.vue?vue&type=script&lang=js"

import "./ComplianceOnboardingWizard.vue?vue&type=style&index=0&id=606f947d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606f947d"]])

export default __exports__